import { render, staticRenderFns } from "./CertificateDetail.vue?vue&type=template&id=28d42d0e&scoped=true&"
import script from "./CertificateDetail.vue?vue&type=script&lang=js&"
export * from "./CertificateDetail.vue?vue&type=script&lang=js&"
import style0 from "./CertificateDetail.vue?vue&type=style&index=0&id=28d42d0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d42d0e",
  null
  
)

export default component.exports